import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { isPicture, isVideo } from '../../../utils/helpers';
import GlobalPreloader from '../../../components/Preloader/GlobalPreloader';
import { likePractice } from '../../../utils/api/services/statistic';
import Preloader from '../../../components/Preloader/Preloader';
import AuthorBlock from '../../../components/User/AuthorBlock';

export default class PracticeDetailCaseAside extends Component {
  static propTypes = {
    practice: PropTypes.object.isRequired,
    className: PropTypes.string
  };

  constructor(props) {
    super(props);

    this.LIKES_TOTAL = 20;

    this.state = {
      likeIsLoading: false,
      showMyLikeInfo: false,
      likeResponse: null,
      isLiked: this.props.practice.isLiked
    };
  }

  like = () => {
    this.setState({ likeIsLoading: true });
    likePractice(this.props.practice.id, false)
      .then((response) => {
        this.setState({
          showLikeError: false,
          likeResponse: response,
          isLiked: response.isLiked,
          showMyLikeInfo: true
        });
      })
      .catch((e) => {
        if (e.status === 400 && e.data) {
          this.setState({
            showLikeError: true,
            likeErrorMessage: e.data.message,
            showMyLikeInfo: true
          });
        } else {
          console.log(e);
        }
      })
      .finally(() => {
        this.setState({ likeIsLoading: false });
      });
  };

  render() {
    const { practice, className } = this.props;
    const {
      showMyLikeInfo,
      likeResponse,
      likeIsLoading,
      showLikeError,
      likeErrorMessage,
      isLiked
    } = this.state;
    return (
      <div className={classNames('article-detail-desc-aside  -mobile-offset', className)}>
        <div className="box -simple">
          <div className="info-box">
            <div className="info-box-cell">
              <div className="info-box-title">Опубликовал:</div>

              <div className="info-box-desc">
                <AuthorBlock
                  user={practice.author}
                  dateFormat="full"
                  createDate={practice.createdDate}
                  className=""
                  // toPost={`${paths.advocates.topic}/${topic.alias}#${comment.id}`}
                />
              </div>
            </div>

            <div className="info-box-cell">
              <div className="info-box-title">В разделе:</div>
              <div className="info-box-desc ">{practice.contestCategory}</div>
            </div>

            {practice.contestTags && practice.contestTags.length ? (
              <div className="info-box-cell">
                <div className="info-box-title">Тэги:</div>
                <div className="info-box-desc">
                  <div className="tags">
                    {practice.contestTags.map((contest, idx) => (
                      <span key={idx} className="tags-item no-pointer-events">
                        {contest}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            ) : (
              ''
            )}

            {practice.inContest && (
              <div className="info-box-cell -btns-group">
                <div className="tip">
                  <button
                    className={classNames('btn info-box-btn practice-like-button', {
                      'practice-like-button--liked': isLiked
                    })}
                    disabled={likeIsLoading}
                    onClick={this.like}
                  >
                    {isLiked ? (
                      'Вам это понравилось'
                    ) : (
                      <React.Fragment>
                        <i className="icon icon-favorite--small" />
                        {' Мне нравится!'}
                      </React.Fragment>
                    )}
                  </button>
                  {showMyLikeInfo && !likeIsLoading && (
                    <div className="tip-block">
                      {showLikeError ? (
                        likeErrorMessage
                      ) : isLiked ? (
                        <React.Fragment>
                          <strong>Вы поставили лайк.</strong>
                          {` У вас осталось ${likeResponse.leftLikesCount} лайков из ${
                            this.LIKES_TOTAL
                          }. Вы можете отозвать свой лайк в любой момент до завершения конкурса`}
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <strong>Вы отозвали лайк.</strong>
                          {` У вас осталось ${likeResponse.leftLikesCount} лайков из ${
                            this.LIKES_TOTAL
                          }.`}
                        </React.Fragment>
                      )}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
